import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../auth/api/auth.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
})
export class ToolbarComponent implements OnInit {
  constructor(private authService: AuthService) {}

  isAuthenticated$: Observable<boolean>;
  ngOnInit(): void {
    this.isAuthenticated$ = this.authService.isAuthenticated;
  }

  onLogout() {
    localStorage.removeItem('token');
    this.authService.logout();
  }
}
